module.exports = __webpack_public_path__ + "img/f4ace92.jpg";